import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';
import { fetchUserAttributes } from "aws-amplify/auth";
import { apiGetUserByEmail, logoutCognitoUser } from 'apis/UserApi';
import { useNavigate } from 'react-router-dom';

const Context = createContext({});

export default function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();

    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    }
  }, [])

  const checkAuth = async () => {
    try {
      const CONFIRM_TOTP_SETUP_STEP = localStorage.getItem('CONFIRM_TOTP_SETUP_STEP');
      const AUTO_LOGIN = localStorage.getItem('AUTO_LOGIN') === 'true';
      const LEAVE_TIME = localStorage.getItem('LEAVE_TIME');

      if (CONFIRM_TOTP_SETUP_STEP === 'true') {
        await logoutCognitoUser();
        localStorage.setItem('CONFIRM_TOTP_SETUP_STEP', false);
        navigate("/login");
      } else {
        const userAttr = await fetchUserAttributes();
        if (!AUTO_LOGIN && (new Date().getTime() - Number(LEAVE_TIME) > 5000)) {
          await logoutCognitoUser();
          return navigate("/login")
        }
        const currUser = await apiGetUserByEmail(userAttr.email);
        setCurrentUser(currUser);
      }
    }
    catch (err) {
      navigate("/login")
    }
  }

  const onBeforeUnload = () => {
    localStorage.setItem('LEAVE_TIME', new Date().getTime());
  }

  return (
    <Context.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </Context.Provider>
  );
}

export const useAuth = () => useContext(Context);
